export const navigationItems = [
    {path: '/app', translationKey: 'navigation:home'},
    {path: '/app/orders', translationKey: 'navigation:nav_orders'},
    {path: '/app/items', translationKey: 'navigation:nav_items'},
    {path: '/app/recipes', translationKey: 'navigation:nav_recipes'},
    {path: '/app/customers', translationKey: 'navigation:nav_customers'},
    {path: '/app/analytics', translationKey: 'navigation:analytics'},
    {path: '/app/finances', translationKey: 'navigation:nav_finances'},
    {path: '/app/settings', translationKey: 'navigation:settings'},
    {path: '/app/feedback', translationKey: 'navigation:feedback'},
] as const;

export const getActiveNavigationPath = (pathname: string) =>
    navigationItems.find(item => item.path !== '/app' && pathname.startsWith(item.path))?.path ?? '/app';
